// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf } from "@altostra/type-validations";
import { string } from "@altostra/type-validations/lib/primitives";

const dragAndDropContentBlockItem = objectOf({
  id: string,
  name: string,
  dnd_json: string,
});

export const isDragAndDropContentBlocksResponse = objectOf({
  results: arrayOf(dragAndDropContentBlockItem),
});
